// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1726) return "static/chunks/1726-48c0df605bfffd45.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 501 ? "bc98253f" : chunkId) + "." + {"501":"db25afafffe73788","5902":"6c454a2e37cd4e5e","7049":"1f25c435b1e30415","8372":"06bcce9d7a4a1822","9795":"042e30780a8d053d"}[chunkId] + ".js";
};